import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminInbox() {
  const [messages, setMessages] = useState([]);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get("/admin/contact-messages").then((r) => setMessages(r.data)).catch(() => {});
    api.get("/admin/email-logs").then((r) => setLogs(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-inbox">
      <h1 className="font-serif-display text-3xl text-white font-light mb-8">Inbox</h1>

      <h2 className="font-sans-body text-xs uppercase tracking-[0.25em] text-[#C6A15B] mb-4">Contact Messages</h2>
      <div className="space-y-3 mb-12">
        {messages.length === 0 && (
          <div className="gold-hairline bg-[#0D0D0D] p-8 text-center font-sans-body text-sm text-[#B8B8B8]">No messages yet.</div>
        )}
        {messages.map((m) => (
          <div key={m.id} className="gold-hairline bg-[#0D0D0D] p-5" data-testid={`inbox-message-${m.id}`}>
            <div className="flex flex-wrap gap-3 items-center">
              <span className="font-sans-body text-sm text-white">{m.name}</span>
              <a href={`mailto:${m.email}`} className="font-sans-body text-xs text-[#D4AF37]">{m.email}</a>
              <span className="font-sans-body text-[10px] text-[#666666]">{new Date(m.created_at).toLocaleString()}</span>
              <span className={`ml-auto font-sans-body text-[10px] uppercase tracking-[0.15em] ${m.email_status === "sent" ? "text-emerald-400" : "text-[#C6A15B]"}`}>
                {m.email_status === "sent" ? "Emailed to you" : m.email_status === "stored_email_failed" ? "Stored (email failed)" : "Stored"}
              </span>
            </div>
            <p className="font-sans-body text-xs text-[#C6A15B] mt-2">{m.subject}</p>
            <p className="font-sans-body text-sm text-[#B8B8B8] font-light mt-2 whitespace-pre-wrap">{m.message}</p>
          </div>
        ))}
      </div>

      <h2 className="font-sans-body text-xs uppercase tracking-[0.25em] text-[#C6A15B] mb-4">Email Delivery Log</h2>
      <div className="space-y-2">
        {logs.length === 0 && (
          <div className="gold-hairline bg-[#0D0D0D] p-8 text-center font-sans-body text-sm text-[#B8B8B8]">No emails sent yet.</div>
        )}
        {logs.map((l) => (
          <div key={l.id} className="gold-hairline bg-[#0D0D0D] px-5 py-3 flex flex-wrap gap-3 items-center font-sans-body text-xs" data-testid={`email-log-${l.id}`}>
            <span className={`uppercase tracking-[0.15em] text-[10px] ${l.status === "sent" ? "text-emerald-400" : "text-red-400"}`}>{l.status}</span>
            <span className="text-[#B8B8B8]">{l.kind?.replace(/_/g, " ")}</span>
            <span className="text-white">{l.to}</span>
            <span className="ml-auto text-[#666666]">{new Date(l.created_at).toLocaleString()}</span>
            {l.error && <span className="w-full text-red-400/80 text-[10px]">{l.error}</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
